import actions from "./actions";

const initState = {
  order: {},
  orders: {
    data: [],
  },
  loading: false,
  acceptRejectOrder: false,
  message: null,
  type: null,
};

export default function fetchOrdersReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_ORDERS_REQUESTED:
      return {
        ...state,
        orders: {
          data: [],
        },
        loading: true,
      };
    case actions.FETCH_ORDERS_SUCCEEDED:
      return {
        ...state,
        orders: action.orders,
        loading: false,
      };
    case actions.FETCH_ORDERS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.FETCH_ORDER_REQUESTED:
      return {
        ...state,
        order: {},
        loading: true,
      };
    case actions.FETCH_ORDER_SUCCEEDED:
      return {
        ...state,
        order: action.order,
        loading: false,
      };
    // TODO fix duplicate case code blocks
    case actions.FETCH_ORDER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.REJECT_ORDER_SUCCEEDED:
      return {
        ...state,
        acceptRejectOrder: true,
        order: action.order,
        message: "Rejected Successfully!",
        type: "success",
      };
    case actions.ACCEPT_ORDER_SUCCEEDED:
      return {
        ...state,
        acceptRejectOrder: true,
        order: action.order,
        message: "Accepted Successfully!",
        type: "success",
      };
    case actions.REJECT_ORDER_FAILED:
      return {
        ...state,
        acceptRejectOrder: true,
        order: action.order,
        message: action.error,
        type: "danger",
      };

    case actions.SETTLE_BULK_ORDER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.SETTLE_BULK_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        settleMessage: action.message || "Orders settled successfully",
        settleType: "success",
        notSettledOrders: action.not_settled_orders || [],
      };
    case actions.SETTLE_BULK_ORDERS_FAILED:
      return {
        ...state,
        loading: false,
        settleMessage: action.error || "Failed to settle orders",
        settleType: "danger",
      };

    case actions.SETTEL_ORDER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.SETTEL_ORDER_SUCCEEDED:
      return {
        ...state,
        loading: false,
        settleMessage: action.message || "Order settled successfully",
        settleType: "success",
      };
    case actions.SETTEL_ORDER_FAILED:
      return {
        ...state,
        loading: false,
        settleMessage: action.error || "Failed to settle order",
        settleType: "danger",
      };
    case actions.DELETE_ORDER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.DELETE_ORDER_SUCCEEDED:
      return {
        ...state,
        orders: action.orders,
        loading: false,
      };
    case actions.DELETE_ORDER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.CANCEL_ORDER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.CANCEL_ORDER_SUCCEEDED:
      return {
        ...state,
        // orders: action.orders,
        loading: false,
      };
    case actions.CANCEL_ORDER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.CHANGE_SUPPLIER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.CHANGE_SUPPLIER_SUCCEEDED:
      return {
        ...state,
        loading: false,
      };
    case actions.CHANGE_SUPPLIER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.CHANGE_ORDER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.CHANGE_ORDER_SUCCEEDED:
      return {
        ...state,
        order: action.order || state.order,
        loading: false,
        message: "Order updated successfully!",
        type: "success",
      };
    case actions.CHANGE_ORDER_FAILED:
      return {
        ...state,
        loading: false,
        message: action.error || "Failed to update order",
        type: "danger",
      };
    case actions.SELECT_GIFT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.SELECT_GIFT_SUCCEEDED:
      return {
        ...state,
        loading: false,
      };
    case actions.SELECT_GIFT_FAILED:
      return {
        ...state,
        loading: false,
      };

    case actions.UPLOAD_CLIQ_PROOF_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.UPLOAD_CLIQ_PROOF_SUCCEEDED:
      return {
        ...state,
        loading: false,
        order: action.order,
      };
    case actions.UPLOAD_CLIQ_PROOF_FAILED:
      return {
        ...state,
        loading: false,
      };

    case actions.CHANGE_SERVICE_FEES_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.CHANGE_SERVICE_FEES_SUCCEEDED:
      return {
        ...state,
        loading: false,
      };
    case actions.CHANGE_SERVICE_FEES_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.CHANGE_ORDER_STATUS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.CHANGE_ORDER_STATUS_SUCCEEDED:
      return {
        ...state,
        loading: false,
      };
    case actions.CHANGE_ORDER_STATUS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.MARK_ITEM_RETURNED_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.MARK_ITEM_RETURNED_SUCCEEDED:
      return {
        ...state,
        order: action.order || state.order,
        loading: false,
        message: "Item marked as returned successfully!",
        type: "success",
        markItemReturnedCreditCoupon: action.credit_coupon || null,
        markItemReturnedError: null,
      };
    case actions.MARK_ITEM_RETURNED_FAILED:
      return {
        ...state,
        loading: false,
        message: action.error || "Failed to mark item as returned",
        type: "danger",
        markItemReturnedError: action.error || "Failed to mark item as returned",
        markItemReturnedCreditCoupon: null,
      };
    case actions.ACCEPT_ITEM_RETURN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.ACCEPT_ITEM_RETURN_SUCCEEDED:
      return {
        ...state,
        order: action.order || state.order,
        loading: false,
        message: "Return request accepted successfully!",
        type: "success",
        acceptItemReturnCreditCoupon: action.credit_coupon || null,
        acceptItemReturnError: null,
      };
    case actions.ACCEPT_ITEM_RETURN_FAILED:
      return {
        ...state,
        loading: false,
        message: action.error || "Failed to accept return request",
        type: "danger",
        acceptItemReturnError: action.error || "Failed to accept return request",
        acceptItemReturnCreditCoupon: null,
      };
    case actions.REJECT_ITEM_RETURN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.REJECT_ITEM_RETURN_SUCCEEDED:
      return {
        ...state,
        order: action.order || state.order,
        loading: false,
        message: "Return request rejected successfully!",
        type: "success",
        rejectItemReturnError: null,
      };
    case actions.REJECT_ITEM_RETURN_FAILED:
      return {
        ...state,
        loading: false,
        message: action.error || "Failed to reject return request",
        type: "danger",
        rejectItemReturnError: action.error || "Failed to reject return request",
      };
    case actions.APPLY_COPAYMENT_REQUESTED:
      return {
        ...state,
        loading: true,
        message: null,
        type: null,
      };
    case actions.APPLY_COPAYMENT_SUCCEEDED:
      return {
        ...state,
        order: action.order || state.order,
        loading: false,
        message: "Co-payment applied successfully!",
        type: "success",
      };
    case actions.APPLY_COPAYMENT_FAILED:
      return {
        ...state,
        loading: false,
        message: action.error || "Failed to apply co-payment",
        type: "danger",
      };
    case actions.REFUND_ALL_ITEMS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.REFUND_ALL_ITEMS_SUCCEEDED:
      return {
        ...state,
        order: action.order || state.order,
        loading: false,
        message: "All items refunded successfully!",
        type: "success",
        refundAllItemsCreditCoupon: action.credit_coupon || null,
        refundAllItemsError: null,
      };
    case actions.REFUND_ALL_ITEMS_FAILED:
      return {
        ...state,
        loading: false,
        message: action.error || "Failed to refund all items",
        type: "danger",
        refundAllItemsError: action.error || "Failed to refund all items",
        refundAllItemsCreditCoupon: null,
      };
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        message: null,
        type: null,
      };
    default:
      return state;
  }
}
